export default "__VITE_ASSET__BSw7pyDe__"